import { useMemo } from 'react'

import {
  OrdersTable,
  reatomOrdersTable,
} from '@root/widgets/trade/tables/orders-table'

import type { Pair } from '@root/entities/pair'

type AnalyticsViewProps = {
  pair: Pair.PairMinimal
}

export const OrdersViewTable: React.FC<AnalyticsViewProps> = ({ pair }) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomOrdersTable(pair.address), [pair])

  return <OrdersTable clickable={false} tableModel={model} />
}
